import { writable } from 'svelte/store';
import { RatingTypes } from '../enums/question-rating.enum';
import type { IConfigStore } from '../interfaces/store-config.interface';
import { WidgetType } from '../enums/widget-type.enum';
import { TogglePositionTypes } from '../enums/toggle-position-types.enum';
import { CsatRatingTypes } from '../enums/csat-rating.enum';
import { CSATTypes } from '../enums/csat-types.enum';
import { WidgetFeatureType } from '../enums/widget-feature.enum';

export const ConfigStore = writable<IConfigStore>({
  productName: '',
  widgetType: WidgetType.cb,
  noGreeting: false,
  widgetParentEle: undefined,
  apiBaseUrl: undefined,
  assetBaseUrl: '',
  logoMain: '',
  logoMini: '',
  toggleSrcHtml: undefined,
  toggleSrcImg: undefined,
  toggleInitShowDelay: 0,
  twoStageOpen: 'off',
  twoStageOpenLabel: '',
  twoStageOpenTimeout: 8000,
  twoStageOpenHoldTime: 600,
  togglePosition: TogglePositionTypes.rightBottom,
  customCSSUrl: '',
  customCSSIntegrity: undefined,
  customInlineCSS: '',
  speechInputOn: true,
  modeSwitchOptions: [],
  modeSwitchDefault: undefined,
  agentName: 'Grace',
  agentTagline: 'AI Assistant',
  searchSuggestion: false,
  searchSuggestionMinLength: 1,
  searchSuggestionMaxHits: 5,
  showFAQ: false,
  canClearChatHistory: false,
  historyResetMessage:
    'The assistant has been updated and can no longer use earlier messages as context. Please repeat any details that are still relevant.',
  customAttributes: undefined,
  agentImg: undefined,
  serverConfig: undefined,
  widget: undefined,
  reasoningMode: 'none',
  cacheMsg: [],
  injectDatetime: 'never',
  suggestQuestions: 'never',
  suggestQuestionsPrompt: 'suggested_search',
  filterCitations: 'no',
  whitelistedDomains: undefined,
  loadThreadHistory: false,
  sendFunctionResult: true,
  functionResultConfig: undefined,
  functionObjectName: 'gqa_functions',
  greetingOnToggle: false,
  greetingOnToggleDelay: 5000,
  greetingExpiryTime: 21600000,
  customTheme: {
    msgBubbleUserBg: undefined,
    msgBubbleUserTextColor: undefined,
    msgBubbleAgentBg: undefined,
    msgBubbleAgentTextColor: undefined,
    badgeBg: undefined,
    badgeIconColor: undefined,
    bodyBg: undefined,
    bodyBorderColor: undefined,
    headerBg: undefined,
    headerTextColor: undefined,
    launchRightPos: '20px',
    launchBottomPos: '10px',

    launchRightMobilePos: undefined,
    launchBottomIpad: undefined,

    /** html text & image launcher */
    buttonWidthHtml: '265px',
    bottomImagePos: '0px',
    rightImagePos: '-86px',
    rightTextHtmlPos: '46px',
    bottomTextHtmlPos: '0px',
    maxHeightImage: '200px',
    paddingHtml: '20px',
    bgColorHtml: '#326297',
    borderHtml: '4px solid #326297',
    borderRadiusHtml: '4px',
    textColorHtml: '#fff',
    textSizeHtml: '20px',

    /** New theme */
    answerQuestionThemeTypes: undefined,
    chatbotAppearanceThemeType: undefined,
    iconThemeType: undefined,
    headerThemeType: undefined,
    loadingThemeType: undefined,
    loadingTextThemeType: 'One moment please...',
    colorThemeType: undefined,
    launcherThemeType: undefined,

    /** Height of cb */
    smallSizeThemeType: undefined,

    /** Custom logo and button for new launcher theme  */
    textButtonThemeType: undefined,
    launcherGalaxyBgThemeType: undefined,
    launcherLogoHtmlThemeType: undefined,
  },
  showBranding: false,
  headerCustomHtml: '',
  sessionInactivityTimeout: undefined,
  conversationIdleTimeout: 300,

  // depreciate [todo]
  ratingType: RatingTypes.thumbs,
  hyperlinkTargetType: '_self',
  alternativeReqCount: 5,
  showAnswerDesc: true,
  showAnswerSourceLink: false,
  toggleAlternative: true,
  showDocDataOnNoAnswer: false,
  ratingDelay: 5000,
  searchStringMinLength: 1,
  searchStringMaxLength: 200,
  ratingNegativeSuggestion: [
    'Incorrect answer',
    'Not enough information',
    'Answer is too long',
    'Site is too slow',
    'Hard to use',
    'Other',
  ],
  showSelectAllIndices: true,
  mediaSharing: true,
  excludeMediaSharing: [],
  /** CSAT **/
  showCsat: false,
  csatTypes: CSATTypes.multitime,
  csatTitleQuestion: '',
  csatVersion: CsatRatingTypes.version_1,
  csatTheme: {
    launchRightPos: '91px',
    launchBottomPos: '99px',
    launchBottomMobilePos: '231px',
  },

  showCsatResponse: true,
  csatResponseTitle: '',
  csatResponseDescription: '',
  csatResponseTime: 2147483647,

  i18n: {},

  /** Contact email form **/
  showContactWindow: false,
  contactFormTitle: '',
  contactFormSubTitle: '',
  contactForEmailTitle: '',
  contactFormEmailPlaceholder: '',
  contactFormButtonText: '',

  /** Add to cart **/
  showAddToCart: false,

  /** Extensible feature list (extend with more features in the future) */
  features: [
    {
      name: WidgetFeatureType.addFiles,
      enabled: false,
      customConfig: { numberOfFiles: 1, fileTypes: [], maxFileSizeMb: 10 },
    },
  ],

  /** Additional links **/
  additionalLink: [],

  /** Different style for scroll **/
  scrollBehavior: false,

  /** Different style for input search **/
  isTextAreaSearch: false,

  /** Placeholder text search **/
  placeholderSearch: '',

  /** Label for input */
  isLabelInput: false,

  /** Label for identify name */
  isIdentifyName: false,

  /** Name toggler button */
  nameTogglerBtn: '',
});
